var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import Link from "../../Link/Link";
import { useTheme } from "../../ThemeProvider/ThemeProvider";
var StyledSideBarItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0.5rem 0.25rem 1rem;\n  width: fit-content;\n  positon: relative;\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0.5rem 0.25rem 1rem;\n  width: fit-content;\n  positon: relative;\n  color: ", ";\n"])), function (props) {
    return props.$selected
        ? props.$colorPalette.primary.accentScale[11]
        : props.$colorPalette.primary.grayScale[11];
});
var SideBarItem = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, size = _a.size, selected = _a.selected, 
    //Events
    onClick = _a.onClick;
    var colorPalette = useTheme().theme.colorPalette;
    return (_jsx(StyledSideBarItem, __assign({ "$colorPalette": colorPalette, onClick: onClick }, { children: typeof children === "string" ? (_jsx(Link, __assign({ tabIndex: onClick ? 0 : undefined, color: selected ? "primary" : undefined, size: size, variant: "hover", className: className, style: style, onClick: onClick }, { children: children }))) : (children) })));
};
export default SideBarItem;
var templateObject_1;
